/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { CreatePortal1MutationRequest, CreatePortal1MutationResponse, CreatePortal1QueryParams, CreatePortal1400, CreatePortal1401, CreatePortal1403, CreatePortal1404, CreatePortal1409, CreatePortal1500 } from "../../types/CreatePortal1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getCreatePortal1Url() {
  const res = { method: 'POST', url: `/api/stripe/portal` as const }
  return res
}

/**
 * @description Creates a Stripe Billing Portal session for the organisation admin. The portal lets the admin manage subscriptions, add/remove seats, and update billing details. Returns the portal URL to redirect the admin to.
 * @summary Create Billing Portal Session
 * {@link /api/stripe/portal}
 */
export async function createPortal1(data: CreatePortal1MutationRequest, params?: CreatePortal1QueryParams, config: Partial<RequestConfig<CreatePortal1MutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreatePortal1MutationResponse, ResponseErrorConfig<CreatePortal1400 | CreatePortal1401 | CreatePortal1403 | CreatePortal1404 | CreatePortal1409 | CreatePortal1500>, CreatePortal1MutationRequest>({ method : "POST", url : getCreatePortal1Url().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}